import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catCanales } from "../Categorias y Estados/catCanales";
import { estActivo } from "../Categorias y Estados/estActivo";
import { Empresas } from "../Empresas/Empresas";
import { GruposEmpresas } from "../GruposEmpresas/GruposEmpresas";
import { GruposEmpresasCadenas } from "../GruposEmpresas/GruposEmpresasCadenas";
import { Areas } from "../Regiones/Areas/Areas";
import { Regiones } from "../Regiones/Regiones";
import { SubAreas } from "../Regiones/SubAreas/SubAreas";
import { TiendasFilters } from "./TiendasFilters/TiendasFilters";

const columns = () =>
(
    {
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Tienda ID' }),
        c_empresa_id: new EntityColumn<string>({ name: 'c_empresa_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Empresa' }),
        c_grupoempresa_id: new EntityColumn<string>({ name: 'c_grupoempresa_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Grupo' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre de la tienda' }),
        vc_codigoexterno: new EntityColumn<string>({ name: 'vc_codigoexterno', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Código externo' }),
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Cadena' }),
        vc_canales: new EntityColumn<string>({ name: 'vc_canales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Canales', isArray: true }),
        c_activo_id: new EntityColumn<string>({ name: 'c_activo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
        c_region_id: new EntityColumn<string>({ name: 'c_region_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Región' }),
        c_area_id: new EntityColumn<string>({ name: 'c_area_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Area' }),
        c_subarea_id: new EntityColumn<string>({ name: 'c_subarea_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Subarea' }),
        vc_domicilio_ruteo: new EntityColumn<string>({ name: 'vc_domicilio_ruteo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Domicilio Ruteo' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        tien_brwStandard: {
            name: 'tien_brwStandard', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new TiendasFilters(client, parentKeys)
        },
        tien_brwPorGrupo: { name: 'tien_brwPorGrupo', keyMappings: { c_tienda_id: 0, c_grupoempresa_id: -1 } }
    }
)
const lookups = () =>
(
    {
        'Empresas': {
            name: 'Empresas',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Empresas(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new GruposEmpresasCadenas(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        },
        'GruposEmpresas': {
            name: 'GruposEmpresas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new GruposEmpresas(client, parentKeys)
        },
        'Regiones': {
            name: 'Regiones',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Regiones(client, parentKeys)
        },

        'Areas': {
            name: 'Areas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Areas(client, parentKeys)
        },

        'SubAreas': {
            name: 'SubAreas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new SubAreas(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estActivo(client, parentKeys)
        }
    }
)


export class TiendasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Tiendas');
    }
}